"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCard = void 0;
const styles_1 = require("@mui/material/styles");
const Card_1 = __importDefault(require("@mui/material/Card"));
exports.StyledCard = (0, styles_1.styled)(Card_1.default)(({ theme }) => ({
    padding: "32px 28px",
    borderRadius: "8px",
    boxShadow: theme.shadows[2]
}));
